module.exports = __webpack_public_path__ + "img/상암 소고기.63a0475b.png";